try {
  window.$ = window.jQuery = require('jquery');
  window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
  window.AOS = require('aos/dist/aos');

  require('@popperjs/core');

  require('./components/Menu');
  require('./components/Slider');
  require('./components/Accordion');
  require('./components/Sidebar');
  require('./components/Eula');
  require('./components/Download');
} catch (e) {
  console.error(e);
}

$(function () {
  AOS.init({
    startEvent: 'DOMContentLoaded',
    once: true,
    duration: 800,
    offset: 20,
    disable: window.matchMedia('(prefers-reduced-motion: reduce)').matches || 'mobile',
  });

  let $preloader = $('[data-preloader="load"]');

  if ($preloader.length > 0) {
    setTimeout((e) => {
      $('body').addClass('loaded');
      $preloader.addClass('loaded');
    }, 150);
  }

  function setMainContentHeight() {
    let $main = $('main');
    let $header = $('#top');
    let $footer = $('#footer');
    let $window_h = window.innerHeight;
    let $404_page = $('.uq-heading-404');

    if ($window_h > $main.outerHeight()) {
      $main.css('min-height', $window_h - $header.outerHeight() - $footer.outerHeight());
    }

    if ($404_page.length > 0) {
      $404_page.css('min-height', $window_h - $header.outerHeight() - $footer.outerHeight());
    }
  }

  let $sameHeightDivs = $('.splitted-module .inner-content');

  function setSameHeight() {
    let minHeight = 0;

    $sameHeightDivs.each(function () {
      minHeight = Math.max(minHeight, $(this).outerHeight());
    });

    $sameHeightDivs.css({ 'min-height': minHeight + 'px' });
  }

  function resetSameHeight() {
    $sameHeightDivs.css({ 'min-height': 'unset' });
  }

  let isVideoLoaded = false;

  function loadVideoOnDesktop() {
    if (window.innerWidth >= 575) {
      const $video = $('#video-background');

      if ($video.length > 0 && !isVideoLoaded) {
        isVideoLoaded = true;

        // Changes data-src to src to only load in desktop
        $('source', $video).each(function () {
            const el = $(this);

            el.attr('src', el.data('src'));
          },
        );

        $video[0].load();
      }
    } else {
      isVideoLoaded = false;
    }
  }

  setSameHeight();
  setMainContentHeight();
  loadVideoOnDesktop();

  $(window).on('load', function () {
    setTimeout(() => {
      AOS.refresh();
    }, 100);

    console.log('Document is ready!!');
  });

  $(window).on('resize', function (e) {
    setMainContentHeight();

    if (window.innerWidth > 574) {
      resetSameHeight();
      setSameHeight();
      loadVideoOnDesktop();
    }
  });
});
